import { H6, Image, LI, P, UL } from '../../../../AbstractElements';
import JobSearchContext from '../../../../Context/JobSearch';
import React, { Fragment, useContext } from 'react';
import { Card, Col, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';

const CardsClass = ({ jobClass, limit, ribbion, col12 }) => {
  const { jobData } = useContext(JobSearchContext);
  return (
    <Fragment>
      {jobData &&
        jobData.slice(0, limit).map((item) => {
          return (
            <Col className={`col-auto ${limit === item.Id && col12 ? 'col-xl-12 xl-100 box-col-12' : jobClass}`} key={item.Id}>
              <Card className={`${item.ribbion && ribbion ? 'ribbon-vertical-left-wrapper' : ''}`}>
                {item.ribbion ? (
                  <div className={`ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary ${!ribbion && 'd-none'}`}>
                    <i className='icofont icofont-love'></i>
                  </div>
                ) : (
                  ''
                )}
                <div className='job-search'>
                  <CardBody>
                    <div className='d-sm-flex align-items-start'>
                      <Image className='img-40 img-fluid mx-auto m-sm-r-20' src={require(`../../../../assets/images/${item.logo}`)} alt='' />
                      <div className='flex-grow-1'>
                        <H6 className='f-w-600'>
                          <Link to={`${process.env.PUBLIC_URL}/job-search/job-details`}>{item.job_name}</Link>
                          {item.type === 'new' ? <span className='badge badge-primary pull-right'>{item.badgeValue}</span> : <span className='pull-right'>{item.type}</span>}
                        </H6>
                        <P>
                          {item.job_area}, {item.job_city}
                        </P>
                        <UL className='rating simple-list'>
                          <LI>
                            <i className='fa fa-star font-warning me-1'></i>
                          </LI>
                          <LI>
                            <i className='fa fa-star font-warning me-1'></i>
                          </LI>
                          <LI>
                            <i className='fa fa-star font-warning me-1'></i>
                          </LI>
                          <LI>
                            <i className='fa fa-star font-warning me-1'></i>
                          </LI>
                          <LI>
                            <i className='fa fa-star font-warning m-0'></i>
                          </LI>
                        </UL>
                      </div>
                    </div>
                    <P>{item.Job_description}</P>
                  </CardBody>
                </div>
              </Card>
            </Col>
          );
        })}
    </Fragment>
  );
};
export default CardsClass;
